import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { intersperse } from '@mews/fp';
import { lt } from '@mews/framework';
import { SimpleInvoice } from '@mews-commander/data-access';
import { Stack, Typography } from '@optimus-web/core';
import { EnterpriseLink, SpacedComma } from '@mews-commander/ui';

export const LinkedInvoices = ({ invoices }: { invoices: SimpleInvoice[] }) => {
    return (
        <Stack vertical spacing="50">
            <Typography as="p" variant="primary" textStyle="bodyMediumStrong">
                {lt('LinkedInvoices', { count: invoices.length })}
            </Typography>

            <Typography textStyle="bodyMedium" as="span">
                {pipe(
                    invoices,
                    array.map((linkedInvoice) => (
                        <EnterpriseLink
                            key={linkedInvoice.invoiceId}
                            variant="basic"
                            underline={false}
                            to="Bill/Detail/$id"
                            params={{ id: linkedInvoice.invoiceId }}
                        >
                            {linkedInvoice.invoiceNumber}
                        </EnterpriseLink>
                    )),
                    intersperse(SpacedComma)
                )}
            </Typography>
        </Stack>
    );
};
